import {useLocation} from 'react-router-dom'
import {useQuery} from '@tanstack/react-query'
import {useServerContext} from '@salesforce/pwa-kit-react-sdk/ssr/universal/hooks'

const useDisableGtm = () => {
    const {search} = useLocation()

    const {data: disabled} = useQuery(
        ['disableGtm'],
        async () => {
            const query = new URLSearchParams(search)
            return !!query.get('disableGtm')
        },
        // this config replicates the existing behavior where gtm disabled is controlled by the initial url
        {
            networkMode: 'always',
            staleTime: Infinity,
            cacheTime: Infinity,
            retry: false,
            retryOnMount: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            // force run on server as we need it to tune the helmet config
            forceOnServer: true,
            meta: {displayName: 'useDisableGtm'}
        }
    )

    // expose the value for helmet-config to use in ssr
    const {res} = useServerContext()
    if (res) {
        res.locals.disableGtm = disabled
    }

    return disabled
}

export default useDisableGtm
